import axios from "axios";
import config from "../config";

const bookingService = axios.create({
  baseURL: config("service").booking,
});

export default bookingService;
